import { Icon } from '@aqarmap/aqarmap-ui';
import { PackageFaqType } from '~/types/packagesType';

export default function PackageFaqItem({
  faq,
  isOpen,
  onClick,
  isFirstItem = false,
}: {
  faq: PackageFaqType;
  isOpen: boolean;
  onClick: () => void;
  isFirstItem?: boolean;
}) {
  return (
    <div
      className={`border-b border-gray px-0 pb-2x md:px-2x md:py-3x ${
        isFirstItem ? 'pt-0 md:pt-3x' : 'pt-2x'
      }`}
    >
      <button
        type="button"
        onClick={onClick}
        className="flex w-full items-start justify-between gap-2x text-start"
      >
        <div className="flex-1">
          <p className="text-body-1 text-black">{faq.question}</p>
        </div>
        <div className="flex size-[24px] items-center justify-center shrink-0 text-gray__dark_2">
          <Icon
            name="chevron-down"
            size="24px"
            className={isOpen ? 'rotate-180' : ''}
          />
        </div>
      </button>
      {isOpen ? (
        <p className="pt-2x text-body-2 text-gray__dark_1">{faq.answer}</p>
      ) : null}
    </div>
  );
}
